import { SplashScreen } from "@inventory/components/common/SplashScreen";
import { AxiosInventoryRoleProvider } from "@inventory/context/AxiosContext";

import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuthState } from "igfd-commons/src/auth";
import { AxiosAuthTokenProvider } from "igfd-commons/src/http";

/**
 * Layout for authenticated pages.
 * Redirects to /login if the user is not signed in.
 * Adds the Firebase auth token + INVENTORY_MANAGER role header to axios calls.
 */
export const AuthenticatedLayout = () => {
  const { loading, user } = useAuthState();

  if (loading) {
    return <SplashScreen />;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <AxiosAuthTokenProvider>
      <AxiosInventoryRoleProvider>
        <Outlet />
      </AxiosInventoryRoleProvider>
    </AxiosAuthTokenProvider>
  );
};
